<template>
  <div dusk="editar-usuario">
    <div id="editar-usuario" class="vx-row">
      <vs-col vs-lg="8" vs-md="8" vs-sm="12" class="vx-col mb-4">
        <vx-card
          ref="dadosUsuarioCard"
          class="h-full"
          title="Dados do Usuário"
          subtitle="Abaixo ficam os dados do usuário."
          cardBorder
          noShadow
        >
          <editar-dados-usuario v-model="usuario" ref="dadosUsuarioRef"></editar-dados-usuario>
        </vx-card>
      </vs-col>
      <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
        <vx-card
          ref="dadosAcessoCard"
          class="h-full"
          title="Dados de Acesso"
          subtitle="Abaixo ficam os dados para acessar o sistema."
          cardBorder
          noShadow
        >
          <editar-dados-acesso v-model="acesso" ref="dadosAcessoRef"></editar-dados-acesso>
        </vx-card>
      </vs-col>
    </div>
    <!-- Salvar -->
    <div class="faixa-white">
      <vs-button
        @click="salvarUsuario()"
        type="relief"
        size="large"
        class="btn-float font-bold"
        id="EditarUsuario"
      >
        <feather-icon class="align-middle inline-block mr-2" icon="SaveIcon" />Salvar
      </vs-button>
    </div>
    <!-- Salvar -->
  </div>
</template>

<script>
import EditarDadosUsuario from "./components/EditarDadosUsuario.vue";
import EditarDadosAcesso from "./components/EditarDadosAcesso.vue";
import api from "@services/api-service";
import queryParams from "@services/repository-service";

export default {
  components: {
    EditarDadosUsuario,
    EditarDadosAcesso
  },
  provide() {
    return {
      $validator: this.$validator
    };
  },
  data() {
    return {
      loading: false,
      usuario: {},
      acesso: {}
    };
  },
  mounted() {
    setTimeout(this.getUsuario, 100);
  },
  watch: {
    loading(loading) {
      const cards = [this.$refs.dadosUsuarioCard, this.$refs.dadosAcessoCard];

      if (loading) {
        cards.map(card => card.refreshcard());
      } else {
        cards.map(card => card.removeRefreshAnimation());
      }
    }
  },
  methods: {
    getUsuario() {
      this.loading = true;

      api()
        .get(`usuarios/${this.$route.params.id}`, {
          params: queryParams({
            relationships: ["usuarioTipo", "entidade", "associacao", "parceiro"]
          })
        })
        .then(response => {
          if (response.data.status) {
            this.usuario = { ...response.data.data };
            this.acesso = { ...response.data.data };
          }
        })
        .finally(() => (this.loading = false));
    },
    validarFormulario() {
      const formularios = [
        this.$refs.dadosUsuarioRef,
        this.$refs.dadosAcessoRef
      ];

      return Promise.all(
        formularios.map(async function(child) {
          const valido = await child.$validator.validateAll();
          if (!valido) {
            switch (child.$options.name) {
              case "editar-dados-usuario":
                throw Error("Complete os dados do usuário.");
              case "editar-dados-acesso":
                throw Error("Complete os dados de acesso.");
              default:
                throw Error();
            }
          }
        })
      );
    },
    async salvarUsuario() {
      try {
        await this.validarFormulario();

        this.loading = true;

        // SALVAR USUARIO
        let usuarioResponse = await api().put(`usuarios/${this.usuario.id}`, {
          ...this.usuario,
          ...this.acesso
        });

        if (!usuarioResponse.data.status)
          throw Error("Ocorreu um erro ao atualizar usuário.");

        this.alertaSucesso("Usuário atualizado com sucesso.");
      } catch (error) {
        this.alertaErro(error.message);
      }

      this.loading = false;
    },
    alertaSucesso(text) {
      this.$vs.notify({
        title: "Sucesso!",
        text: text,
        color: "success",
        iconPack: "feather",
        icon: "icon-check",
        position: "bottom-center"
      });
    },
    alertaErro(text) {
      this.$vs.notify({
        title: "Erro.",
        text: text,
        color: "danger",
        iconPack: "feather",
        icon: "icon-alert-circle",
        position: "bottom-center",
        time: 10000
      });
    }
  }
};
</script>



